import ExamsQuestionsModel from '../Apis/ExamsQuestions'
import Controller from './Controller'

export default class ExamsQuestionsController extends Controller {
  constructor() {
    super(new ExamsQuestionsModel())
  }
}
